'use strict';

var React = require('react');

var SvgAppsFilledIcon = function SvgAppsFilledIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 3.625c.483 0 .875.392.875.875v1.125h1.125a.875.875 0 0 1 0 1.75h-1.125v1.125a.875.875 0 0 1-1.75 0v-1.125h-1.125a.875.875 0 0 1 0-1.75h1.125v-1.125c0-.483.392-.875.875-.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.75 3.75a2 2 0 0 0-2 2v2.75c0 .414.336.75.75.75h4a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0-.75-.75h-2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 14.25a2 2 0 0 0 2 2h2.75a.75.75 0 0 0 .75-.75v-4a.75.75 0 0 0-.75-.75h-4a.75.75 0 0 0-.75.75v2.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 16.25a2 2 0 0 0 2-2v-2.75a.75.75 0 0 0-.75-.75h-4a.75.75 0 0 0-.75.75v4c0 .414.336.75.75.75h2.75Z"
  }));
};
SvgAppsFilledIcon.displayName = "AppsFilledIcon";

exports.SvgAppsFilledIcon = SvgAppsFilledIcon;
